<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card v-if="!pageloading" outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
             <v-col class="pb-0" cols="12" md="12">
              <el-text-field
                label="Sistemos pranešimo pavadinimas"
                v-model="formData.title"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
                 <el-textarea
              required
              :counter="2000"
              label="Pradinio lango informacinio pranešimo tekstas (LT)"
              v-model="formData.text_lt"
            /></v-col>
            <v-col class="pb-0" cols="12" md="12">
                 <el-textarea
              required
              :counter="2000"
              label="Pradinio lango informacinio pranešimo tekstas (EN)"
              v-model="formData.text_en"
            />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" >
              <el-date-picker
                label="Pranešimo rodymo data (ribojimas nuo) nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.date_from"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" >
              <el-text-field
              required
              timeMask
              placeholder="00:00"
              label="Pranešimo rodymo laikas nuo"
              v-model="formData.time_from"
            /></v-col>
            <v-col class="pb-0" cols="12" md="6" >
              <el-date-picker
                label="Pranešimo rodymo data (ribojimas nuo) iki"
                :afterDate="formData.date_from"
                :disabled="modeReadonly"
                v-model="formData.date_to"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" >
              <el-text-field
              timeMask
              placeholder="00:00"
              label="Pranešimo rodymo laikas iki"
              v-model="formData.time_to"
            /></v-col>
                <v-col cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.application"
                  enums
                  required
                  multiple
                  itemvalue="value"
                  itemtext="text"
                  label="Pranešimas rodomas"
                  v-model="formData.applications"
                />
              </v-col>
             <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-text-field
                label="Kodas"
                disabled
                v-model="code"
                :maxlength="20"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import Enums from '@/enums'

export default {
  name: 'AdminSystemNotificationsForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {
        time_from: "",
        time_to: "",
      },
      enumsClassifiers: [],
      code: '',
    }
  },
  computed: {
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti sistemos pranešimą`)
      } else {
        return this.$t(`Naujas sistemos pranešimas`)
      }
    },
  },
  created() {
    if (this.getId) {
      this.getData()
    }
    this.getClassifiers()
  },
  methods: {
    setDateTyme(onSave){
      if(onSave){
        let validFrom = `${this.formData.date_from} ${this.formData.time_from}`
        let validTo = `${this.formData.date_to || ''} ${this.formData.time_to || ''}`
        this.formData.valid_from = validFrom
        this.formData.valid_to = validTo || ''
      } else {
        this.pageloading = true
        let validFrom = this.formData.valid_from.split(' ') || ''
        let validTo = this.formData.valid_to ? this.formData.valid_to.split(' ') : ''
        this.$set(this.formData, 'date_from', validFrom[0] || '')
        this.$set(this.formData, 'date_to', validTo[0] || '')
        this.$set(this.formData, 'time_from', validFrom[1] || '')
        this.$set(this.formData, 'time_to', validTo[1] || '')
        this.$nextTick(() => {
          this.pageloading = false
        })
      }

    },
    getClassifiers() {
       this.enumsClassifiers = Enums
    },
    back() {
      this.$router.push({ name: 'adminSystemNotifications' })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`system-notifications/${this.getId}`)
        .then((res) => {
          this.formData = res.data.systemNotification
          this.code = this.formData.code
          this.setDateTyme()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          this.setDateTyme(true)
          let formData = this.formData
          formData.code = this.code
          let url = `system-notifications`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss"></style>
